import { render, staticRenderFns } from "./CopyToClickboard.vue?vue&type=template&id=56ea3e22"
import script from "./CopyToClickboard.vue?vue&type=script&lang=js"
export * from "./CopyToClickboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports